import { render, staticRenderFns } from "./name-only-form.vue?vue&type=template&id=bc5720ac"
import script from "./name-only-form.vue?vue&type=script&lang=js"
export * from "./name-only-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports